import { render, staticRenderFns } from "./PurchasePlanListFunc.vue?vue&type=template&id=604accc6&scoped=true&"
import script from "./PurchasePlanListFunc.vue?vue&type=script&lang=js&"
export * from "./PurchasePlanListFunc.vue?vue&type=script&lang=js&"
import style0 from "./PurchasePlanListFunc.vue?vue&type=style&index=0&id=604accc6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604accc6",
  null
  
)

export default component.exports